<form *ngIf="airSearchForm" [formGroup]="airSearchForm" (ngSubmit)="onSubmit()">
    <ng-container *permissionIf="eAirSearchPermissions.IQBA_SEARCHFORM_SECTOR">
        <air-search-segment-oneway-return *ngIf="wayType !== eWayType.Multiple"
            (emitSegmentValues)="segmentValues=$event"
            [wayType]="wayType"
            [segmentValues]="segmentValues"></air-search-segment-oneway-return>
        <air-search-segment-multiple *ngIf="wayType === eWayType.Multiple"
            (emitSegmentValues)="segmentValues=$event"
            [segmentLength]="multipleSegmentLength"
            [segmentValues]="segmentValues"
            [airSearchContext]="airSearchContext"></air-search-segment-multiple>
    </ng-container>
    <air-search-quantity-form
        *permissionIf="eAirSearchPermissions.IQBA_SEARCHFORM_QUANTITY"
        [disabled]="airSearchContext === eAirSearchContext.watabi || airSearchContext === eAirSearchContext.updateBooking"></air-search-quantity-form>
    <div class="fieldFlex">
        <ng-container *ngIf="wayType === eWayType.Multiple">
            <air-search-host-form *permissionIf="eAirSearchPermissions.IQBA_SEARCHFORM_HOST"></air-search-host-form>
            <air-search-locator-form></air-search-locator-form>
            <air-search-keyword-form
                    *permissionIf="eAirSearchPermissions.IQBA_SEARCHFORM_KEYWORD"></air-search-keyword-form>
            <ng-container *ngIf="showFlexibilityForm">
                <air-search-flexibility-form
                        *permissionIf="eAirSearchPermissions.IQBA_SEARCHFORM_PLUSORMINUS"></air-search-flexibility-form>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="wayType !== eWayType.Multiple">
            <air-search-keyword-form
                    *permissionIf="eAirSearchPermissions.IQBA_SEARCHFORM_KEYWORD"></air-search-keyword-form>
            <ng-container *ngIf="showFlexibilityForm">
                <air-search-flexibility-form
                        *permissionIf="eAirSearchPermissions.IQBA_SEARCHFORM_PLUSORMINUS"></air-search-flexibility-form>
            </ng-container>
            <air-search-cabin-form *permissionIf="eAirSearchPermissions.IQBA_SEARCHFORM_CABIN_USE"></air-search-cabin-form>
            <air-search-max-vias-form *permissionIf="eAirSearchPermissions.IQBA_SEARCHFORM_MAXVIAS_USE"></air-search-max-vias-form>
            <air-search-host-form *permissionIf="eAirSearchPermissions.IQBA_SEARCHFORM_HOST"></air-search-host-form>
            <air-search-locator-form></air-search-locator-form>
        </ng-container>
    </div>
    <ng-container *ngIf="isMoreCriteria">
        <btnForm styleType="actionLink" formType="button" (click)="isMoreCriteriaToggle=!isMoreCriteriaToggle">
            {{wording.moreCriteria}}
            <fa-icon [icon]="!isMoreCriteriaToggle ? iconDown : iconUp"></fa-icon>
        </btnForm>
        <div class="fieldFlex moreCriteria" [style.display]="isMoreCriteriaToggle ? 'flex' : 'none'">
            <air-search-fare-type-form
                    *permissionIf="eAirSearchPermissions.IQBA_SEARCHFORM_ADDITIONAL_PRICE"></air-search-fare-type-form>
            <air-search-carrier-form
                    *permissionIf="eAirSearchPermissions.IQBA_SEARCHFORM_ADDITIONAL_CARRIER"></air-search-carrier-form>
            <air-search-price-form
                    *permissionIf="eAirSearchPermissions.IQBA_SEARCHFORM_ADDITIONAL_PRICE"></air-search-price-form>
        </div>
    </ng-container>
    <btnForm styleType="actionPrincipal" [formType]="'submit'"
             [disabled]="!airSearchForm.valid">{{wording.airSearchAction}}</btnForm>
</form>
